import { hasServiceConsent } from './consent';

// Provider SDKs can retain automatic events/batches after consent is revoked.
// Enforce the current choice at transmission, not just when an event is queued.
export function trackingRequestAllowed(input: string): boolean {
  let url: URL;
  try { url = new URL(input, location.href); } catch { return true; }
  const host = url.hostname;
  if (host === 'facebook.com' || host.endsWith('.facebook.com') || host.endsWith('.facebook.net')) return hasServiceConsent('metaPixel');
  if (host === 'google-analytics.com' || host.endsWith('.google-analytics.com')) return hasServiceConsent('ga4');
  if (host === 'doubleclick.net' || host.endsWith('.doubleclick.net') || (/^([\w-]+\.)?google\.[a-z.]+$/.test(host) && /\/(pagead|ccm|rmkt)\//.test(url.pathname))) return hasServiceConsent('googleAds');
  return true;
}

let installed = false;
export function installTrackingTransportGuard(): void {
  if (installed) return;
  installed = true;
  const originalFetch = window.fetch;
  window.fetch = function (input, init) {
    const url = input instanceof Request ? input.url : String(input);
    if (!trackingRequestAllowed(url)) return Promise.resolve(new Response(null, { status: 204 }));
    return originalFetch.call(this, input, init);
  };
  const originalBeacon = navigator.sendBeacon;
  navigator.sendBeacon = function (url, data) {
    return trackingRequestAllowed(String(url)) ? originalBeacon.call(this, url, data) : false;
  };
  const urls = new WeakMap<XMLHttpRequest, string>();
  const originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method: string, url: string | URL, async = true, username?: string, password?: string) {
    urls.set(this, String(url));
    originalOpen.call(this, method, url, async, username, password);
  };
  const originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function (body) {
    if (!trackingRequestAllowed(urls.get(this) ?? '')) { this.abort(); return; }
    originalSend.call(this, body);
  };
  const descriptor = Object.getOwnPropertyDescriptor(HTMLImageElement.prototype, 'src');
  if (descriptor?.set) {
    const setter = descriptor.set;
    Object.defineProperty(HTMLImageElement.prototype, 'src', {
      ...descriptor,
      set(value: string) { if (trackingRequestAllowed(String(value))) setter.call(this, value); },
    });
  }
  const originalSetAttribute = Element.prototype.setAttribute;
  Element.prototype.setAttribute = function (name, value) {
    if (this instanceof HTMLImageElement && name.toLowerCase() === 'src' && !trackingRequestAllowed(value)) return;
    originalSetAttribute.call(this, name, value);
  };
}